
const Definition = {

    plan_level: 1,
    id: "launchpad",
    name: "Launchpad",
    path: "team/launchpad/components/Landing",
    preview_image: "https://img.freepik.com/free-vector/gradient-rocket-background_23-2148146034.jpg?semt=ais_hybrid&w=740&q=80",
    colors: {
        red: "#EF4444",
        dark: "#0A0A0F",
        gold: "#C9A84C",
        text: "#E8E8F0",
        dark2: "#111118",
        dark3: "#1A1A24",
        dark4: "#22222E",
        green: "#22C55E",
        muted: "#7A7A96",
        accent: "#4F6EF7",
        orange: "#F97316",
        gold_light: "#C9A84C",
    }

};

export default Definition;
